<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="年级班级名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入年级班级名称" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="form.status" button-style="solid">
            <a-radio-button
              :value="item.value"
              v-for="(item, index) in statusList"
              :key="index"
            >
              {{ item.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="排序" prop="classSort" v-if="type == 'edit'">
          <a-input v-model="form.classSort" placeholder="请输入排序" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { Classlist } from "@/api";
import { mapState } from "vuex";
export default {
  components: {},
  computed: {
    ...mapState("user", ["schoolId"]),
  },
  data() {
    return {
      title: "",
      type: "",
      confirmLoading: false,
      visible: false,
      formData: {
        id: "",
        name: "",
        classSort: "99",
        status: "1",
        schoolId: "",
      },
      form: {},
      statusList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入年级班级名称!",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入学校地址!",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态!",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    async open(type, data) {
      this.type = type;
      this.title = type == "edit" ? "编辑班级" : "添加班级";
      this.visible = true;
      this.form = JSON.parse(JSON.stringify(this.formData));
      if (type == "edit" && data) {
        this.form = JSON.parse(JSON.stringify(data));
        this.form.status = data.status + "";
        delete this.form.createTime;
        delete this.form.updateTime;
      }
      // 获取数据字典
      this.statusList = await this.common.getSysCodeType("SYS_STATUS");
      console.log(this.statusList);
    },

    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));
          newForm.schoolId = this.schoolId;
          if (this.type == "add") {
            delete newForm.id;
          }
          this.submitSave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 提交
    submitSave(data) {
      this.confirmLoading = true;
      console.log(data);
      Classlist.gradeClassSave(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage(
            this.type == "edit" ? "修改成功！" : "添加成功！",
            "success"
          );
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.$refs.ruleForm.resetFields();
      this.form = JSON.parse(JSON.stringify(this.formData));
    },
  },
};
</script>
